import { useEffect, useState } from "react";
import { setUser, logoutUser, useAppDispatch, useAppSelector } from "../redux";

export const useAuthCheck = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token");
      const userData = localStorage.getItem("userData");

      // Consider user authenticated if we have a valid token + user data.
      // Some flows (like Google login) may not issue a refresh token.
      if (token && userData) {
        try {
          const user = JSON.parse(userData);
          dispatch(setUser(user));
        } catch (error) {
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("userData");
          dispatch(logoutUser());
        }
      } else if (isAuthenticated) {
        // Only logout if currently authenticated but required data is missing
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userData");
        dispatch(logoutUser());
      }
      setIsLoading(false);
    };

    // Check auth immediately
    checkAuth();

    // Set up interval to check auth periodically (only if authenticated)
    const intervalId = setInterval(() => {
      if (isAuthenticated) {
        checkAuth();
      }
    }, 30000); // Check every 30 seconds

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [dispatch, isAuthenticated]);

  return isLoading;
};
